import { DateTime } from 'luxon'

/**
 * @function
 * @description Receives a internation date and convert to BR format
 * @name convertDateToBR
 * @param {String} internationalDate YYYY-MM-DD
 * @returns {String} date on brazilian format DD/MM/YYYY
 */
export const convertDateToBR = internationalDate => {
  if (!internationalDate) return
  return DateTime.fromFormat(internationalDate, 'yyyy-MM-dd')
    .setLocale('pt-br')
    .toLocaleString()
}

/**
 * @function
 * @description Receives an international date and returns in the pattern "Segunda, 22 de Maio"
 * @name convertDateToBRLong
 * @param {String} brazilianDate DD/MM/YYYY
 * @returns {String | undefined} date in the format "Segunda, 22 de Maio"
 */
export const convertDateToBRLong = (
  brazilianDate: string
): string | undefined => {
  if (!brazilianDate) return
  const date = DateTime.fromFormat(brazilianDate, 'dd/MM/yyyy').setLocale(
    'pt-BR'
  )
  if (!date.isValid) return

  const weekday = date.toFormat('cccc').replace('-feira', '')
  const day = date.toFormat('d')
  const month = date.toFormat('LLLL')
  const monthCapitalized = month.charAt(0).toUpperCase() + month.slice(1)
  const weekdayCapitalized = weekday.charAt(0).toUpperCase() + weekday.slice(1)
  return `${weekdayCapitalized}, ${day} de ${monthCapitalized}`
}

export const convertDateToLocalTimeZone = (strDate: string) => {
  if (!strDate) return

  const gmtDateString = strDate

  const gmtDate = new Date(gmtDateString)
  const localTimeZoneOffset = new Date().getTimezoneOffset()

  gmtDate.setMinutes(gmtDate.getMinutes() - localTimeZoneOffset)

  return gmtDate
}

export const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
]

export const MONTHS_FILTERS = [
  {
    id: 1,
    monthNumber: 0,
    label: 'Janeiro'
  },
  {
    id: 2,
    monthNumber: 1,
    label: 'Fevereiro'
  },
  {
    id: 3,
    monthNumber: 2,
    label: 'Março'
  },
  {
    id: 4,
    monthNumber: 3,
    label: 'Abril'
  },
  {
    id: 5,
    monthNumber: 4,
    label: 'Maio'
  },
  {
    id: 6,
    monthNumber: 5,
    label: 'Junho'
  },
  {
    id: 7,
    monthNumber: 6,
    label: 'Julho'
  },
  {
    id: 8,
    monthNumber: 7,
    label: 'Agosto'
  },
  {
    id: 9,
    monthNumber: 8,
    label: 'Setembro'
  },
  {
    id: 10,
    monthNumber: 9,
    label: 'Outubro'
  },
  {
    id: 11,
    monthNumber: 10,
    label: 'Novembro'
  },
  {
    id: 12,
    monthNumber: 11,
    label: 'Dezembro'
  }
]
